// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dot-wrap__DotButton_2Wq1f {\n  display: flex;\n  justify-content: center;\n}\n", ""]);
// Exports
exports.locals = {
	"dot-wrap": "dot-wrap__DotButton_2Wq1f",
	"dotWrap": "dot-wrap__DotButton_2Wq1f"
};
module.exports = exports;
